import { render } from "./ExpenseInput.vue?vue&type=template&id=43f9ea53&ts=true"
import script from "./ExpenseInput.vue?vue&type=script&lang=ts"
export * from "./ExpenseInput.vue?vue&type=script&lang=ts"

import "./ExpenseInput.vue?vue&type=style&index=0&id=43f9ea53&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__